module.exports = __webpack_public_path__ + "static/bizum_qr-862ae10adcb6cabbdddde98ba9beff07.svg";